import { useSelector } from 'react-redux';
import { emailSendModalSelectors } from '@/ModalWindows/EmailSendModal/services/selectors';
import { useEmailSendModalActions } from '@/ModalWindows/EmailSendModal/hooks/useEmailSendModalActions';

export const useSingleDocumentPrintModal = () => {
  const selectedTypeNumbers = useSelector(emailSendModalSelectors.selectedTypeNumbers);

  const { sendExistingDocuments } = useEmailSendModalActions();

  const sendSingleDocument = () => {
    sendExistingDocuments(selectedTypeNumbers);
  };

  return {
    sendSingleDocument,
  };
};
